var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$store.getters.isEnterprise)?_c('enterprise-portfolio'):_vm._e(),(_vm.$store.getters.isEcosystem)?_c('ecosystem-portfolio'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }